import NumberFormat from "react-number-format";

import { ProgressBar } from "../../reusableUI/v2UI/ProgressBar";

export const CardPrices = (props) => {
  const {
    title,
    total,
    percent,
    label,
    bgColor,
    textColor,
    formatMoney,
    hasProgress = true,
  } = props;

  return (
    <div className="bg-white p-3 flex flex-col gap-1 rounded-xl border border-border">
      <span className="text-xs font-medium uppercase tracking-wide">
        {title}
      </span>
      <span className={`${textColor} text-2xl font-semibold tracking-wide`}>
        <NumberFormat
          className="items-prices"
          value={total || 0}
          displayType={"text"}
          thousandSeparator={formatMoney.thousandSeparator}
          decimalSeparator={formatMoney.decimalSeparator}
          prefix={`${formatMoney.prefix} `}
          decimalScale={2}
          fixedDecimalScale
        />
      </span>
      <span className="text-xs text-gray-500 tracking-wide mt-1">
        {hasProgress && (
          <NumberFormat
            value={percent}
            displayType={"text"}
            thousandSeparator={","}
            decimalSeparator="."
            decimalScale={2}
            fixedDecimalScale
            suffix="%"
          />
        )}
        <span className="ms-1 tracking-wide">{label}</span>
      </span>
      {hasProgress && (
        <span className="mt-2">
          <ProgressBar porcentaje={percent} color={bgColor} />
        </span>
      )}
    </div>
  );
};
